export function capitalizeAndFormat(words) {
  if (!words) {
    return words;
  }
  let wordArray;
  if (words) {
    wordArray = words.split('/');
  }
  for (let i = 0; i < wordArray.length; i += 1) {
    const subword = wordArray[i].trim().split(' ');
    for (let j = 0; j < subword.length; j += 1) {
      subword[j] = subword[j][0].toUpperCase() + subword[j].slice(1);
    }
    wordArray[i] = subword.join(' ');
  }
  return wordArray.join(', ');
}
export function getFilteredText(text) {
  const regexHtml = /(<([^>]+)>)/gi;
  const removedHtmlTagText = text?.trim()?.replace(regexHtml, ' ');
  const escapeCharactersRegexList = [/&nbsp;/gi, /&lt;/gi, /&gt;/gi, /&amp;/gi];
  let filteredText = removedHtmlTagText;
  for (let i = 0; i < escapeCharactersRegexList?.length; i += 1) {
    filteredText = filteredText?.trim()?.replace(escapeCharactersRegexList[i], '');
  }
  return filteredText;
}

// Space look-alikes: a visible gap that is not U+0020. A name pasted from Word, Outlook or a
// web page routinely carries one, and it survives every check built on \s -- which matches
// these -- only to break the first consumer that splits on a literal ' '.
const UNICODE_SPACE_REGEX = /[\t\n\v\f\r\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]/g;

// Zero-width characters, dropped rather than turned into a space: they occupy no width, so
// replacing one with a space would split a single name into two.
const ZERO_WIDTH_REGEX = /[\u00ad\u200b-\u200d\u2060\ufeff]/g;

// An HTML-encoded space that survived a copy as plain text.
const ENCODED_SPACE_REGEX = /&nbsp;|&#160;|&#x0*a0;/gi;

// Neutralises the characters a pasted name carries but a typed one never does. Deliberately
// does not trim or collapse, so it is safe to run on every keystroke -- trimming as the user
// types would swallow the space between first and last name before they finish typing it.
// Decode order matters: a decoded &#xA0; is a raw U+00A0 and still needs the pass after it.
export function sanitizeNameInput(value) {
  if (!value) {
    return value;
  }
  return value
    .replace(ENCODED_SPACE_REGEX, ' ')
    .replace(UNICODE_SPACE_REGEX, ' ')
    .replace(ZERO_WIDTH_REGEX, '');
}

// The submit-time form: every separator is a single U+0020 with nothing leading, trailing or
// repeated, so the first/last splits downstream see the tokens the recruiter intended.
export function normalizeFullName(value) {
  if (!value) {
    return value;
  }
  return sanitizeNameInput(value)
    .replace(/ {2,}/g, ' ')
    .trim();
}
